module.exports = __webpack_public_path__ + "assets/img/ic-N.6926474c.png";